import { normalize, schema } from 'normalizr';
import { call, put, take } from 'redux-saga/effects';
import { callApi } from '../../api';
import {
  fetchIdolsCallOptions,
  saveIdolCallOptions,
  updateIdolCallOptions,
} from '../../../services/idols.service';
import { updateIdolEntities, fetchIdols, saveIdol } from './idols.actions';
import * as R from 'ramda';
import { Idol } from './idols.reducer';
import { gotoSite } from '../../Navigation/navigation.actions';
import {IdolProfileImage} from '../../../modules/IdolCreate';

export const idolSchema = new schema.Entity(
  'idols',
  {},
  {
    idAttribute: 'id',
    processStrategy: (entity: {
      id: number;
      name: string;
      gender: string;
      apps: any;
      slug: string;
      profile_id?: number;
      quality?: string;
      images?: IdolProfileImage[];
    }) => {
      const { name } = entity;
      const [firstname, lastname] = name.split(' ');

      return {
        id: entity.id,
        name: entity.name,
        slug: entity.slug,
        gender: entity.gender,
        firstname,
        lastname,
        quality: entity.quality,
        apps: entity.apps && entity.apps.data,
        appIds:
          entity.apps && entity.apps.data
            ? R.map((item: { id: number }) => item.id, entity.apps.data)
            : [],
        images: entity.images
      };
    },
  }
);

export function* fetchAllIdols() {
  const { ok, data } = yield call(callApi, fetchIdolsCallOptions());
  if (ok) {
    const normalized = normalize(data.data, [idolSchema]);
    yield put(updateIdolEntities(normalized.entities.idols));
  }

  yield true;
}

export function* watchIdolFetch() {
  while (true) {
    yield take(fetchIdols.type);
    yield call(fetchAllIdols);
  }
}

export function* storeIdol(idol: Idol) {
  const { ok } = yield call(callApi, saveIdolCallOptions(idol));

  if (ok) {
    yield call(fetchAllIdols);
    yield put(gotoSite('/idols'));
  }
}

export function* updateIdol(idol: Idol) {
  const { ok } = yield call(callApi, updateIdolCallOptions(idol));
  if (ok) {
    yield call(fetchAllIdols);
    yield put(gotoSite('/idols'));
  }
}

export function* watchSaveIdol() {
  while (true) {
    const {
      payload: { idol },
    } = yield take(saveIdol.type);

    if (!idol.id) {
      yield call(storeIdol, idol);
    } else {
      yield call(updateIdol, idol);
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/Entities/Idols/idols.saga.ts